export const parseDevotionals = (devotionals, type = 'txt') => {
    switch (type) {
        case 'txt':
            return devotionalToTxt(devotionals);
        case 'html':
        case 'pdf':
            return devotionalToHtml(devotionals);
    }
};
/**
 * Converts a list of devotionals to a text string. It also removes unneeded new line and let the parser handle it.
 * @param devotionals - The list of devotionals to convert
 * @returns A text string containing the devotionals
 */
const devotionalToTxt = (devotionals) => {
    return `5 Day Devotional\n${devotionals
        .map((devotional, index) => `
Day ${index + 1}: ${devotional.title.replace('\n', '')}

Devotional
${(devotional.devotional || devotional.content).replace('\n', '')}

Bible Verse
${devotional.verse.replace('\n', '')}

Reflection Question
${devotional.question.replace('\n', '')}
${devotional.quote &&
        `Quote
${devotional.quote.replace('\n', '')}`}

${devotional.prayer &&
        `Prayer
${devotional.prayer.replace('\n', '')}`}
${index < devotionals.length - 1 ? '\n\n' : ''}`)
        .join('')}`;
};
/**
 * Converts a list of devotionals to an HTML string.
 * @param devotionals - The list of devotionals to convert
 * @returns An HTML string containing the devotionals
 */
const devotionalToHtml = (devotionals) => {
    return `<h1>5 Day Devotional</h1>${devotionals
        .map((devotional, index) => `
  <h2>Day ${index + 1}: ${devotional.title.replace(/<[^>]+>/g, '')}</h2>
  
  ${(devotional.devotional || devotional.content) &&
        `<h3>Devotional</h3>
      <p>${devotional.devotional || devotional.content}</p>`}

  <h3>Bible Verse</h3>
  ${devotional.verse}
  <h3>Reflection Question</h3>
  ${devotional.question}
  ${devotional?.quote &&
        `<h3>Quote</h3>
      <p>${devotional.quote}</p>`}
  ${devotional?.quote &&
        `<h3>Prayer</h3>
      <p>${devotional.prayer}</p>`}
  ${index < devotionals.length - 1 ? '<br><br>' : ''}`)
        .join('')}`;
};
